module.exports = __webpack_public_path__ + "img/promo-diciembre-ertiga-boostergreen.6c5e5d63.jpg";